import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKanbanView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconKanbanView"><Path d="M9.5 4.5H14.5V19.5H9.5V4.5Z" stroke="currentColor"/><Path d="M2.5 4.5H7.5V15.5H2.5V4.5Z" stroke="currentColor"/><Path d="M16.5 4.5H21.5V13.5H16.5V4.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconKanbanView;
